import React, { createContext, useContext, useState } from 'react';

const baseData = {
  qorbiUserData: null,
  setQorbiUserData: () => { },
  startMission: false,
  setStartMission: () => { },
  devicedUsed: null,
  setDevicedUsed: () => { },
  registerWallet: { show: false, wallet: null },
  setRegisterWallet: () => { },
  registerUser: false,
  setRegisterUser: () => { },
}
const SphereOneContext = createContext(baseData);

const SphereOneProvider = ({ children }) => {
  const [qorbiUserData, setQorbiUserData] = useState(baseData.qorbiUserData);
  const [startMission, setStartMission] = useState(baseData.startMission);
  const [devicedUsed, setDevicedUsed] = useState(baseData.devicedUsed);
  const [registerWallet, setRegisterWallet] = useState(baseData.registerWallet);
  const [registerUser, setRegisterUser] = useState(baseData.registerUser);

  return (
    <SphereOneContext.Provider value={{
      devicedUsed, registerWallet, registerUser, startMission, qorbiUserData,
      setDevicedUsed, setRegisterWallet, setRegisterUser, setStartMission, setQorbiUserData,
    }}>
      {children}
    </SphereOneContext.Provider>
  );
};

export default SphereOneProvider;

export const useSphereOneProvider = () => useContext(SphereOneContext);
